const baseUrl = "Session";

export const getSessionsUrl = () => `${baseUrl}/user-sessions`;
export const getAllSessionsUrl = (studentTypeId, applicationTypeId) =>
	`${baseUrl}/all-sessions${
		studentTypeId ? `?studentTypeId=${studentTypeId}` : ""
	}${applicationTypeId ? `?applicationTypeId=${applicationTypeId}` : ""}`;
export const getSundrySessionsUrl = (paymentPurposeId) =>
	`${baseUrl}/sundry-sessions?paymentPurposeId=${paymentPurposeId}`;
